/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCloseSmallRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M17.636 6.364a.9.9 0 0 1 0 1.272L13.272 12l4.364 4.364a.9.9 0 1 1-1.273 1.272L12 13.273l-4.364 4.363a.9.9 0 1 1-1.273-1.272L10.727 12 6.363 7.636a.9.9 0 1 1 1.273-1.272L12 10.727l4.363-4.363a.9.9 0 0 1 1.273 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCloseSmallRegular;
